export const name = 'rnNotificationService';
export default function rnNotificationService($q, $log, $filter, rnRegistry, rnHttp, rnRecordFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';
  const NOTIFICATION_SERVICE = 'notification_service';
  const PORTAL_SERVICE = 'sms_portal';

  var service = {
    getNotifications: getNotifications,
    getSubscription: getSubscription,
    getSubscriptions: getSubscriptions,
    getApplications: getApplications,
    acknowledgeNotification: acknowledgeNotification,
    getEventDescriptionsByApplication: getEventDescriptionsByApplication,
    removeSubscription: removeSubscription,
    addSubscription: addSubscription,
    createNotificationRecord: createNotificationRecord,
    acknowledgeAllNotifications: acknowledgeAllNotifications,
    loadMoreNotifications: loadMoreNotifications,
    updateFilter: updateFilter,
    notificationHalRequest: notificationHalRequest
  };

  return service;

  ////////////////

  function getNotifications(offset = 0, limit=50) {
    let config = {
      params: {
        offset: offset,
        limit: limit
      }
    };
    return rnHttp.get(NOTIFICATION_SERVICE, '', config).then(({data:notificationData}) => {
      let notificationEventRecords = _.map(notificationData.notificationEvents, createNotificationEventRecord);
      notificationData.notificationEvents = notificationEventRecords;
      return notificationData;
    });
  }

  function getSubscriptions(link) {
	let deferred = $q.defer();
    let config = {};
    notificationHalRequest(link).then(function(resp) {
	  let subscriptionCollection = resp.data;
	  let subscriptionRecords = _.map(subscriptionCollection.userSubscriptionList, createSubscriptionRecord);
	  subscriptionCollection.userSubscriptionList = subscriptionRecords;
	  deferred.resolve(subscriptionCollection);
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function getSubscription(link) {
    let deferred = $q.defer();
    let config = {};
    notificationHalRequest(link).then(function(resp) {
      deferred.resolve(createSubscriptionRecord(resp.data));
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function loadMoreNotifications(link) {
	let deferred = $q.defer();
    let config = {};
    notificationHalRequest(link).then(function(resp) {
      let notificationEvent = resp.data;
      let notificationEventRecord =createNotificationEventRecord(notificationEvent);
      deferred.resolve(notificationEventRecord);
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function createRecord(data) {
    let record = rnRecordFactory.create(data);
    record.setRelativeService(PORTAL_SERVICE);
    return record;
  }

  function createNotificationEventRecord(data) {
    let event = createRecord(data);
    let notificationRecords = _.map(event.notificationEventList, createNotificationRecord);
    event.notificationEventList = notificationRecords;
    return event;
  }

  function createNotificationRecord(data) {
    let notification = createRecord(data);
    //notification.internal.idName = 'eventId';
    return notification;
  }

  function createSubscriptionRecord(data) {
    let subscription = createRecord(data);
    subscription.internal.idName = 'userSubscriptionId';
	  let deliveryRecords = _.map(subscription.deliveryMethods, createDeliveryMethodRecord);
	  subscription.deliveryMethods = deliveryRecords;
    return subscription;
  }

  function createDeliveryMethodRecord(data) {
    let deliveryMethod = createRecord(data);
    deliveryMethod.internal.idName = 'name';
    return deliveryMethod;
  }

  function getApplications(link) {
	let deferred = $q.defer();
    let config = {};
    notificationHalRequest(link).then(function(resp) {
	  let applications = resp.data;
	  deferred.resolve(applications);
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function getEventDescriptionsByApplication(link) {
	let deferred = $q.defer();
    let config = {};
    notificationHalRequest(link).then(function(resp) {
	  let descriptionCollection = resp.data;
	  let descriptionRecords = _.map(descriptionCollection.eventDescriptionList, createEventDescriptionRecord);
	  descriptionCollection.eventDescriptionList = descriptionRecords;
	  deferred.resolve(descriptionCollection);
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

   function createEventDescriptionRecord(data) {
    let description = rnRecordFactory.create(data);
    description.internal.idName = 'eventDescriptionName';

    return description;
  }

  function acknowledgeNotification(link) {
	let deferred = $q.defer();
    let config = {};
    notificationHalRequest(link).then(function(response) {
	  deferred.resolve(createNotificationRecord(response.data));
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function acknowledgeAllNotifications(link) {
	let deferred = $q.defer();
    notificationHalRequest(link).then(function(response) {
	  deferred.resolve();
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function addSubscription(link) {
	let deferred = $q.defer();
    notificationHalRequest(link).then(function(resp) {
	  let subscription = createSubscriptionRecord(resp.data);
	  deferred.resolve(subscription);
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function removeSubscription(link) {
	let deferred = $q.defer();
    notificationHalRequest(link).then(function() {
	  deferred.resolve();
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function updateFilter(link, data) {
	let deferred = $q.defer();
    notificationHalRequest(link, data).then(function(response) {
	  deferred.resolve(createSubscriptionRecord(response.data));
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function notificationHalRequest(link, data, config) {
	let deferred = $q.defer();
	let newLink = angular.copy(link);
    appendServer(newLink.href).then(function(href) {
	  newLink.href = href;
      rnHttp.halRequest(newLink, data, config).then(function(resp) {
        deferred.resolve(resp);
      }).catch(function(err) {
        deferred.reject(err);
      });
    }).catch(function(err) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function appendServer(path) {
    return rnRegistry.getUrl(PORTAL_SERVICE, path);
  }

}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/notification/notification.service.js